import React, { useEffect, useState } from 'react';
import './index.scss';
import { Typography, Tabs, notification, Card, Button, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import API_SERVICE from 'shared/services/api-service';
import ProductCardGrid from '../../components/ProductCardGrid/ProductCardGrid';
import Paragraph from 'antd/es/typography/Paragraph';
import { useHistory } from 'react-router-dom';
import Meta from 'antd/es/card/Meta';
import Parameters from 'shared/parameters';

const { TabPane } = Tabs;

const { Title } = Typography;
export default function CategoriesSection() {
    const { t } = useTranslation();
    const history = useHistory();
    const [categories, setCategories] = useState([] as any[]);
	console.log('categoriesss',categories)
    useEffect(() => {
        API_SERVICE.fetchCategories({ per_page: 8 }).then(({ data: { data: { items } } }) => {
            setCategories(items);
        }).catch((e) => {
            notification.error({
                message: API_SERVICE.handleErrors(e),
            });
        });
    }, []);
    return (
        <div className={'categories-section mb-0'}>
            <div className="container-fluid popular-category pb-5 pl-md-5 pr-md-5">
				<div className="d-flex align-items-center justify-content-space-between">
					<div className="mt-4 max-width-450">
						<h3>{t('genDict.curriculum')}</h3>
						<p>{t('genDict.curriculumParagraph')}</p>
					</div>
					<div className="mt-4">
						{/* <a href="#" className="btn btn-blue text-uppercase">View All</a> */}
					</div>
				</div>
				<div className="container">
					<div className="row justify-content-center">
					{
							categories.map((category: any) => {
								return <div className="col-md-3 col-sm-3 col-6">
											<div className='bg-white p-3' style={{ cursor: 'pointer' }}
											onClick={() => {
												history.push(`/courses?categoryId=${category.id}`);
											} }>
												<div className="pos-relative">
													<img src={Parameters.ImageBaseUrl + category.image.slug + category.image.ext} className="course-cat-icon img-fluid" />
												</div>
												<div>
													{/* <p className="mt-2">{category.name}</p> */}
													<p className="mt-2">{category.name}</p>
													<p className="mt-4 mb-1 text-secondary text-uppercase">{category.active_courses.length} {t('genDict.courses')}</p>
												</div>
											</div>
											
									</div>;
							})
						}
					</div>
				</div>
				<div className="plr-8 mt-3 text-center">
					<button className="btn btn-blue text-uppercase" onClick={() => {
					history.push(`/courses`);
					}}>{t('genDict.Explore')}</button>
				</div>
			</div>
        </div>
    );
}
